<mat-drawer #drawer class="rightpanel" mode="overlay" position="end">
    <div class="container-fluid">
        <div class="close-icon">
            <mat-icon class="icon-close" (click)="righNavClose()">close</mat-icon>
        </div>
        <ng-content></ng-content>
    </div>
</mat-drawer>